/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGameAccessTokenGameAccessTokenAuthData, FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGameAccessTokenGameAccessTokenAuthDataFromJSONTyped, FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGameAccessTokenGameAccessTokenAuthDataToJSON, } from './FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGameAccessTokenGameAccessTokenAuthData';
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenFromJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGameAccessTokenGameAccessTokenAuthData(json)) {
        return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGameAccessTokenGameAccessTokenAuthDataFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenToJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenToJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGameAccessTokenGameAccessTokenAuthData(value)) {
        return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGameAccessTokenGameAccessTokenAuthDataToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessToken.js.map